export default "__VITE_ASSET__ff7721a8__"